
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutUsSection from '../components/sections/AboutUsSection';
import WhatWeDoSection from '../components/sections/WhatWeDoSection';
import ContactCTASection from '../components/sections/ContactCTASection';
import OurStorySection from '../components/sections/OurStorySection';
import TeamSection from '../components/sections/TeamSection';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLanguage } from '@/contexts/LanguageContext';

const AboutNoaPage: React.FC = () => {
  const isMobile = useIsMobile();
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-noa-antiflash-white">
      <Navbar />
      
      <main>
        {/* Full-page color header with updated styling */}
        <section className="relative py-56 bg-[#586F7C] dark:bg-[#586F7C] text-white overflow-hidden min-h-screen flex items-center">
          {/* Background patterns */}
          <div className="absolute inset-0 bg-dot-pattern opacity-10"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/10"></div>
          
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
            <div className="text-center max-w-3xl mx-auto">
              <div className="uppercase text-xs sm:text-sm font-bold tracking-wider text-noa-antiflash-white/80 mb-6 sm:mb-8">
                {t('about_noa_subtitle')}
              </div>
              
              <h1 className="font-space-grotesk text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 sm:mb-8 leading-tight text-noa-antiflash-color">
                {t('trusted_partner_long')}<span className="text-blue-600">.</span>
              </h1>
              
              <p className="text-noa-antiflash-white/80 text-base sm:text-xl max-w-2xl leading-relaxed text-center mx-auto">
                {t('partner_description')}
              </p>

              <div className="mt-12 sm:mt-16 flex justify-center animate-fade-in opacity-0" style={{ animationDelay: "0.5s", animationFillMode: "forwards" }}>
                <p className="text-noa-antiflash-white/70 text-lg">{t('scroll_to_learn_more')}</p>
              </div>
              <div className="flex justify-center mt-4 animate-bounce">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto">
                  <path d="M12 5v14"></path>
                  <path d="m19 12-7 7-7-7"></path>
                </svg>
              </div>
            </div>
          </div>
        </section>
        
        <OurStorySection />
        <AboutUsSection />
        <TeamSection />
        <WhatWeDoSection />
        <ContactCTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutNoaPage;
